<template>
  <div>
    <div class="header" @click="back">
      <i class="el-icon-back" /> | 设备详情
    </div>
    <el-container>
      <el-aside width="70%" style="margin-right: 20px">
        <el-row :gutter="20" class="panel-group">
          <el-col v-if="RoleId === 1" :xs="12" :sm="12" :lg="RoleId === 1?8:12" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div class="title">本月流水</div>
                <count-to
                  :start-val="0"
                  :end-val="headerData?headerData.amount:0"
                  :duration="2600"
                  :decimals="2"
                  class="card-panel-num"
                />
              </div>
              <div class="card-panel-description">
                <img src="@/assets/field-img-01.png" alt="">
              </div>
            </div>
          </el-col>
          <!-- <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-message">
            <div class="title">总用户量</div>
          </div>
          <div class="card-panel-description">
            <count-to :start-val="0" :end-val="100" :duration="2600" :decimals="0" class="card-panel-num"/>
          </div>
        </div>
      </el-col>-->
          <el-col :xs="12" :sm="12" :lg="RoleId === 1?8:12" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div class="title">昨日使用率(%)</div>
                <count-to
                  :start-val="0"
                  :end-val="headerData?(headerData.yesterdayUse/headerData.doorCount)*100:0"
                  :duration="2600"
                  :decimals="2"
                  class="card-panel-num"
                />
              </div>
              <div class="card-panel-description">
                <img src="@/assets/field-img-02.png" alt="">
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="RoleId === 1?8:12" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-icon-wrapper icon-message">
                <div class="title">柜门数</div>
                <count-to
                  :start-val="0"
                  :end-val="headerData?headerData.doorCount:0"
                  :duration="2600"
                  :decimals="0"
                  class="card-panel-num"
                />
              </div>
              <div class="card-panel-description">
                <img src="@/assets/field-img-03.png" alt="">
              </div>
            </div>
          </el-col>
        </el-row>
        <el-card class="el-custom-card custom-card" shadow="never">
          <div slot="header" class="clearfix">
            <el-row :gutter="10" type="flex">
              <el-col :lg="24" class="mb-30">
                <b>箱子列表</b>
                <template v-if="calcPermission(permition, 1)">
                  <el-button class="custom-button" style="margin-left: auto;background: #29C72E" round type="primary" @click="handleBatchClear">批量清理箱子</el-button>
                  <el-button class="custom-button" style="background: #29C72E" round type="primary" @click="handleClears">一键清理箱子</el-button>
                  <el-button class="custom-button" style="background: #1890FF" round @click="handleAddDevice">
                    <i class="el-icon-plus" />
                    添加箱子
                  </el-button>
                </template>
              </el-col>
              <!-- <el-col :lg="2">
            <el-input placeholder="请输入地址" size="mini"/>
          </el-col>-->

            </el-row>
          </div>
          <el-table :data="boxData" fit style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column :label="$t('table.change')" type="selection" align="center" />
            <el-table-column :label="$t('table.BoxNo')" fixed="left" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.BoxNo">{{ scope.row.BoxNo }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.boxLockId')" fixed="left" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.LockId">{{ scope.row.LockId }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.boxLockNum')" fixed="left" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.LockNum">{{ scope.row.LockNum }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="箱子类型" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.TypeNo | filterTypeNo }}</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column :label="$t('table.memberBox')" align="center">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.IsMember"
                >{{ scope.row.IsMember === 'Y' ? '是' : scope.row.IsMember === 'N' ? '否' : '--' }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column> -->
            <el-table-column :label="$t('table.boxUseTotalCount')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.UseTotalCount || 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="RoleId === 1" :label="$t('table.boxTotalIncome')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.TotalIncome || 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.retCoinMoney')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.RetCoinMoney || 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.boxStatusNo')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.StatusNo">
                  <span
                    v-if="scope.row.StatusNo === 'occupy' && scope.row.UserType === 1"
                  >{{ scope.row.StatusNo | filterStatus }}(包月)</span>
                  <span v-else>{{ scope.row.StatusNo | filterStatus }}</span>
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="是否包月箱子" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.UserType?'包月':'非包月' }}</span>
          </template>
        </el-table-column>-->
            <el-table-column :label="$t('table.boxStartTime ')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.StartTime">{{ scope.row.StartTime }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('table.boxTelPhone')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.TelPhone">{{ scope.row.TelPhone }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200" fixed="right">
              <template slot-scope="scope">
                <el-link
                  v-if="calcPermission(permition, 7)"
                  class="custom-link"
                  type="primary"
                  @click="openbox(scope.row)"
                >打开</el-link>
                <el-link
                  v-if="calcPermission(permition, 7)"
                  class="custom-link"
                  type="primary"
                  @click="boxedit(scope.row)"
                >编辑</el-link>
                <el-link
                  v-if="calcPermission(permition, 8)"
                  class="custom-link"
                  type="primary"
                  @click="clearbox(scope.row)"
                >清理</el-link>
                <el-link
                  v-if="calcPermission(permition, 9)"
                  class="custom-link"
                  type="danger"
                  @click="deleted(scope.row)"
                >删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              v-show="boxListTotal>0"
              :current-page="boxListQuery.pageIndex"
              :page-sizes="[10,20,50,100]"
              :page-size="boxListQuery.pageSize"
              :total="boxListTotal"
              layout="total, prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-card>
      </el-aside>
      <el-main>
        <el-card class="el-custom-card custom-card" shadow="never">
          <b>基本参数 The basic parameters</b>
          <p>设备标识号：{{ detailItem.LsList.Identity }}</p>
          <p>设备名称：{{ detailItem.LsList.Name }}</p>
          <p>场地名称：{{ detailItem.FieldName }}</p>
          <p>
            代理商名称：{{ detailItem.AgentName }} ---
            <span
              style="color: #409EFF"
            >手机号：{{ detailItem.AgentTel }}</span>
          </p>
          <!-- <p>
            代理商名称2：{{ detailItem.AgentName1 }} ---
            <span
              style="color: #409EFF"
            >手机号：{{ detailItem.AgentTel1 }}</span>
          </p>
          <p>
            代理商名称3：{{ detailItem.AgentName2 }} ---
            <span
              style="color: #409EFF"
            >手机号：{{ detailItem.AgentTel2 }}</span>
          </p>
          <p>
            代理商名称4：{{ detailItem.AgentName3 }} ---
            <span
              style="color: #409EFF"
            >手机号：{{ detailItem.AgentTel3 }}</span>
          </p>
          <p>
            代理商名称5：{{ detailItem.AgentName4 }} ---
            <span
              style="color: #409EFF"
            >手机号：{{ detailItem.AgentTel4 }}</span>
          </p> -->
          <p>场地地址：{{ detailItem.LsList.Address }}</p>
          <p>
            在线状态：
            <el-link
              :underline="false"
              :type="detailItem.LineState==='On'?'success':''"
            >{{ detailItem.LineState | filterLineStatus }}</el-link>
          </p>
        </el-card>
        <el-card class="el-custom-card custom-card mt-30" shadow="never">
          <b>使用率 Usage</b>
          <line-chart :chart-data="lineChartData" title="使用率%" />
        </el-card>
      </el-main>
    </el-container>

    <!-- 订单列表 -->
    <el-card v-if="calcPermission(permition, 1)" class="el-custom-card custom-card mt-40" shadow="never">
      <div slot="header" class="clearfix">
        <el-row :gutter="10">
          <el-col :lg="2">
            <b>订单流水</b>
          </el-col>
          <el-col :md="10" :lg="2">
            <el-input
              v-model="orderListQuery.identity"
              disabled
              placeholder="请输入设备唯一标识号"

            />
          </el-col>
          <el-col :md="10" :lg="9" :xl="6">
            <el-date-picker
              v-model="value1"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"

              @change="handleTimeChange"
            />
          </el-col>
          <el-col :md="10" :lg="1" :xl="1">
            <el-button round icon="el-icon-search" type="primary" @click="handleOrderSearch">搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <el-table :data="orderData" fit style="width: 100%">

        <el-table-column label="订单编号">
          <template slot-scope="scope">
            <span>{{ scope.row.OrderInfo.OrderNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收费模式">
          <template slot-scope="scope">
            <span>{{ scope.row.OrderInfo.ChargingMode | fileterChangedDuration }}</span>
          </template>
        </el-table-column>
        <el-table-column label="场地名称">
          <template slot-scope="scope">
            <span>{{ scope.row.FieldName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备唯一标识号">
          <template slot-scope="scope">
            <span>{{ scope.row.Identity }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否有押金">
          <template slot-scope="scope">
            <span
              v-if="scope.row.OrderInfo.IsDeposit"
            >{{ scope.row.OrderInfo.IsDeposit === 'Y'?'有押金':'无押金' }}</span>
            <span v-else>无押金</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.PayMoney') + '(元)'" width="100px" align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.OrderInfo.PayMoney || scope.row.OrderInfo.PayMoney === 0"
            >{{ scope.row.OrderInfo.PayMoney }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column :label="`剩余押金(元)`" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.OrderInfo.Deposit">{{ scope.row.OrderInfo.Deposit }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.boxNo')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.OrderInfo.BoxNo }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.userName')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.UserInfo.UserName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.telPhone')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.UserInfo.TelPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.OrderType')" align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.OrderInfo.OrderType"
            >{{ scope.row.OrderInfo.OrderType === 'box' ? '使用箱子' : scope.row.OrderInfo.OrderType === 'member' ? '会员充值' : '--' }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.OrderState')" align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.OrderInfo.OrderState"
            >{{ scope.row.OrderInfo.OrderState === 'A' ? '进行中' : scope.row.OrderInfo.OrderState === 'D' ? '使用中' : scope.row.OrderInfo.OrderState === 'S' ? '订单结束' : '--' }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column :label="`清理类型`" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.OrderInfo.ClearMode | filteClearMode }}</span>
            <!-- <span v-else>0</span> -->
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.PayType')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.OrderInfo.PayType === 'Wx' ? '微信支付' : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="`存放时间`" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.OrderInfo.StartTime }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.endTime')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.OrderInfo.EndTime || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <template v-if="calcPermission(permition, 7)">
              <el-link
                v-if="(scope.row.OrderInfo.RetCoinStatus === 'ERROR' || scope.row.OrderInfo.RetCoinStatus === null) && scope.row.OrderInfo.ClearMode != 0"
                type="danger"
                @click="handleConfirmRefund(scope.row)"
              >退款</el-link>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          v-show="orderListTotal>0"
          :current-page="orderListQuery.pageIndex"
          :page-sizes="[10,20,50,100]"
          :page-size="orderListQuery.pageSize"
          :total="orderListTotal"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleOrderSizeChange"
          @current-change="handleOrderCurrentChange"
        />
      </div>
    </el-card>
    <!-- 添加箱子弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :title="boxFlag?'添加箱子': '编辑箱子'"
      width="40%"
    >
      <el-form ref="box" :model="box" :rules="rules" label-width="120px" class="demo-box">
        <el-form-item :label="$t(`table.BoxNo`)" prop="BoxNo">
          <el-input
            :disabled="!boxFlag"
            v-model="box.BoxNo"
            :placeholder="$t(`table.BoxNo`)"
            type="text"
            maxlength="20"
          />
        </el-form-item>
        <!-- <el-form-item label="箱子规格" prop="TypeNo">
          <el-select v-model="box.TypeNo" placeholder="请选择箱子大小">
            <el-option
              v-for="item in boxTypeArrs"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t(`table.boxLockId`)" prop="LockPlate">
          <el-input
            v-model="box.LockPlate"
            :placeholder="$t(`table.boxLockId`)"
            type="text"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item :label="$t(`table.boxLockNum`)" prop="LockPosition">
          <el-input
            v-model="box.LockPosition"
            :placeholder="$t(`table.boxLockNum`)"
            type="text"
            maxlength="50"
          />
        </el-form-item>
        <!-- <el-form-item :label="$t(`table.memberBox`)" prop="IsMember">
          <el-select
            v-model="box.IsMember"
            :placeholder="$t('table.memberBox')"
            clearable
            class="filter-item"
          >
            <el-option
              v-for="item in memberBoxs"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleDialog('box')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 退款弹窗 -->
    <el-dialog :visible.sync="refundVisible" title="分订单" width="60%">
      <el-table :data="splitOrderData" fit style="width: 100%">
        <el-table-column label="微信订单编号">
          <template slot-scope="scope">
            <span>{{ scope.row.OrderNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户名">
          <template slot-scope="scope">
            <span>{{ scope.row.Name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <span>{{ scope.row.Phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额">
          <template slot-scope="scope">
            <span>{{ scope.row.Money }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间">
          <template slot-scope="scope">
            <span>{{ scope.row.PayTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否退款">
          <template slot-scope="scope">
            <el-link v-if="scope.row.RetCoinStatus === 'ERROR'" type="danger">退款失败</el-link>
            <el-link v-else-if="scope.row.RetCoinStatus === 'SUCCESS'" type="success">退款成功</el-link>
            <el-link v-else>未退款</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <template v-if="calcPermission(permition, 7)">
              <el-link
                v-if="scope.row.flag && (scope.row.RetCoinStatus === 'ERROR' || scope.row.RetCoinStatus === null)"
                type="danger"
                @click="handleConfirmRefund(scope.row)"
              >退款</el-link>
            </template>
          </template>
        </el-table-column> -->
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundVisible = false">取 消</el-button>
        <el-button type="primary" @click="refundVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LineChart from '../dashboard/admin/components/LineChart'
import {
  qryBoxInfo,
  // batchAddDeviceBox,
  deleteBox,
  clearBoxInfo01,
  getDeviceData,
  batchAddDeviceBoxWeb
} from '@/api/device'
import { qryOrderInfo, getSplitOrder, refund } from '@/api/order'
import { qryRoleInfo } from '@/api/baseModule'
import CountTo from 'vue-count-to'
export default {
  name: 'FieldDetail',
  components: {
    CountTo,
    LineChart
  },
  filters: {
    filterTypeNo(value) {
      let str = ''
      switch (value) {
        case 'Small':
          str = '小'
          break
        case 'Mid':
          str = '中'
          break
        case 'Big':
          str = '大'
          break
        case 'SuperBig':
          str = '超级大'
          break
      }
      return str
    },
    fileterChangedDuration(value) {
      let str = ''
      switch (value) {
        case 'Duration':
          str = '时长'
          break
        case 'Frequency':
          str = '次数'
          break
        case 'Month':
          str = '包月'
          break
        case 'DurationStage':
          str = '区间时长'
          break
        case 'Free':
          str = '免费'
          break
      }
      return str
    },
    fileterDurationMode(value) {
      let str = ''
      switch (value) {
        case 'two':
          str = '前X小时X元后续一小时X元'
          break
        case 'one':
          str = 'X小时X元'
          break
      }
      return str
    },
    filterStatus(value) {
      let str = ''
      switch (value) {
        case 'occupy':
          str = '占用'
          break
        case 'free':
          str = '空闲'
          break
        case 'temp':
          str = '临时占用'
          break
        case 'prohibit':
          str = '禁用'
          break
        case 'waitNotify':
          str = '等待通知'
          break
        case 'lock':
          str = '锁定'
          break
        default:
          str = ''
          break
      }
      return str
    },
    filterLineStatus(value) {
      let str = ''
      switch (value) {
        case 'On':
          str = '在线'
          break
        case 'Off':
          str = '离线'
          break
      }
      return str
    },
    filteClearMode(val) {
      let str = ''
      switch (val) {
        case 0:
          str = '用户'
          break
        case 1:
          str = '后台'
          break
        case 2:
          str = '自动'
          break
      }
      return str
    }
  },
  props: {
    detailItem: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  data() {
    return {
      value1: null,
      refundVisible: false,
      splitOrderData: [],
      rules: {
        BoxNo: [{ required: true, message: '请输入箱子编号', trigger: 'blur' }],
        TypeNo: [
          { required: true, message: '请选择箱子规格大小', trigger: 'blur' }
        ],
        LockPlate: [
          { required: true, message: '请输入锁板地址', trigger: 'blur' }
        ],
        LockPosition: [
          { required: true, message: '请输入锁号地址', trigger: 'blur' }
        ],
        IsMember: [
          { required: true, message: '请选择是否是会员柜子', trigger: 'blur' }
        ]
      },
      memberBoxs: [
        {
          id: 'Y',
          name: '是'
        },
        {
          id: 'N',
          name: '否'
        }
      ],
      lineChartData: {
        actualData: [],
        addTime: []
      },
      boxData: [], // 箱子数据
      orderData: [], // 订单数据
      boxListQuery: {
        dId: 0,
        tel: null,
        pageIndex: 1,
        pageSize: 10,
        typeNo: null,
        isMember: null
      },
      orderListQuery: {
        identity: null,
        fieldIds: null,
        startTime: null,
        endTime: null,
        pageIndex: 1,
        pageSize: 10
      },
      boxListTotal: 0,
      orderListTotal: 0,
      dialogVisible: false,
      boxTypeArrs: [
        { value: 'Small', label: '小' },
        { value: 'Mid', label: '中' },
        { value: 'Big', label: '大' },
        { value: 'SuperBig', label: '超级大' }
      ],
      box: {
        BoxNo: null,
        TypeNo: 'Small',
        LockPlate: null,
        LockPosition: null,
        IsMember: null
      },
      headerData: null,
      checked: [],
      boxFlag: true,
      id: null
    }
  },
  created() {
    console.log(this.detailItem)
    this.RoleId = this.$store.getters.roles.RoleId
    this.id = this.boxListQuery.dId = this.detailItem.LsList.DId
    this.orderListQuery.identity = this.detailItem.LsList.Identity
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.getBoxList()
          this.getOrderList()
          this.getDeviceDataList(this.detailItem.LsList.DId)
        }
      })
    } else {
      qryRoleInfo().then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.getBoxList()
            this.getOrderList()
            this.getDeviceDataList(this.detailItem.LsList.DId)
          }
        })
      })
    }
  },
  methods: {
    // 获取设备数据
    getDeviceDataList(did) {
      getDeviceData({ did }).then(res => {
        this.headerData = res
        if (res.list) {
          res.list.forEach(item => {
            this.lineChartData.actualData.push(
              (item.UseCount * 100).toFixed(2)
            )
            const time = item.Time.split(' ')
            this.lineChartData.addTime.push(time[0])
          })
        }
      })
    },
    // 获取箱子列表
    getBoxList() {
      qryBoxInfo(this.boxListQuery).then(res => {
        console.log(res)
        if (res) {
          this.boxData = res.LsList
          this.boxListTotal = res.TotalRows
        }
      })
    },
    // 获取设备下订单信息列表
    getOrderList() {
      qryOrderInfo(this.orderListQuery).then(res => {
        console.log(res)
        if (res) {
          this.orderData = res.LsList.LsList
          this.orderListTotal = res.LsList.TotalRows
        }
      })
    },
    // 添加箱子
    handleAddDevice() {
      this.boxFlag = true
      this.resetBox()
      this.dialogVisible = true
    },
    // // 删除箱子
    deleted(detail) {
      var query = []
      if (detail) {
        query.push(detail.BoxId)
        deleteBox({ boxIds: query }).then(request => {
          if (request) {
            console.log(this.boxListTotal)
            console.log(
              this.boxListQuery.pageIndex * this.boxListQuery.pageSize
            )
            if (
              this.boxListTotal - 1 ===
                (this.boxListQuery.pageIndex - 1) *
                  this.boxListQuery.pageSize &&
              this.boxListTotal - 1
            ) {
              this.boxListQuery.pageIndex--
            }
            this.$message.success('删除成功')
            this.getBoxList()
          }
        })
      } else {
        if (this.checked && this.checked.length > 0) {
          deleteBox({ boxIds: this.checked }).then(request => {
            console.log(request)
            this.$message.success('删除成功')
            this.getBoxList()
          })
        } else {
          this.$message.error('请先选择箱子')
        }
      }
    },
    // 多选
    handleSelectionChange(detail) {
      console.log(detail)
      this.checked = detail.map(item => {
        return item.BoxId
      })
      console.log(this.checked)
    },
    // 打开箱子
    openbox(detail) {
      const boxInfo = new window.proto.SocketCmd.NotifyPayStatus()
      boxInfo.setCmdcode(0x0205)
      boxInfo.setIdentity(this.$store.getters.roles.LogNo)
      boxInfo.setOppositeid(this.Identity)
      boxInfo.setOrderno('-1')
      // boxInfo.setIdentity(this.Identity)
      boxInfo.setTimetoken(new window.Date().getTime())
      boxInfo.setMemo(
        JSON.stringify({
          LockId: detail.LockId,
          LockNum: detail.LockNum,
          type: 2,
          usr: this.$store.getters.roles.LogNo,
          isFree: 'Y'
        })
      )
      this.cySocket.sendMsg(boxInfo.serializeBinary())
    },
    // 清理箱子
    clearbox(detail) {
      clearBoxInfo01({
        Ids: [detail.BoxId],
        type: 0,
        clearMode: 1
      }).then(res => {
        if (res) {
          this.$message.success('清理成功')
          this.getBoxList()
          this.getOrderList()
        }
      })
    },
    // 批量清理箱子
    handleBatchClear() {
      if (this.checked.length > 0) {
        clearBoxInfo01({
          Ids: this.checked,
          type: 0,
          clearMode: 1
        }).then(res => {
          if (res) {
            this.$message({
              type: 'success',
              message: '清理成功'
            })
            this.getBoxList()
            this.getOrderList()
          }
        })
      } else {
        this.$message.error('请选择箱子')
      }
    },
    // 一键清理箱子
    handleClears() {
      clearBoxInfo01({
        Ids: [this.id],
        type: 1,
        clearMode: 1
      }).then(res => {
        if (res) {
          this.$message.success('清理成功')
          this.getBoxList()
          this.getOrderList()
        }
      })
    },
    // 点击空白关闭弹窗
    handleClose(done) {
      this.resetBox()
      done()
    },
    // 取消
    handleCance() {
      this.resetBox()
      this.dialogVisible = false
    },
    // 确定弹窗
    handleDialog(dataForm) {
      this.$refs[dataForm].validate(valid => {
        if (valid) {
          const dataForm = {
            devices: [this.detailItem.LsList.DId],
            boxs: [this.box]
          }
          batchAddDeviceBoxWeb(dataForm).then(res => {
            if (res) {
              this.$message.success('添加成功')
              this.getBoxList()
              this.resetBox()
              this.dialogVisible = false
            }
          })
        }
      })
    },
    // 箱子列表
    boxedit(row) {
      this.boxFlag = false
      console.log(row)
      for (const key in this.box) {
        this.box[key] = row[key]
      }
      this.box['LockPlate'] = row.LockId
      this.box['LockPosition'] = row.LockNum
      this.dialogVisible = true
      console.log(this.box)
    },
    // 搜索订单
    handleOrderSearch() {
      this.getOrderList()
    },
    // 订单时间切换
    handleTimeChange() {
      console.log(this.value1)
      if (this.value1) {
        this.orderListQuery.startTime = this.value1[0]
        this.orderListQuery.endTime = this.value1[1]
      } else {
        this.orderListQuery.startTime = null
        this.orderListQuery.endTime = null
      }
    },
    // 退款订单列表
    handleRefund(item) {
      this.getRefundList(item, 1)
      this.refundVisible = true
    },
    // 获取退款订单
    getRefundList(item, type) {
      const orderId = type ? item.OrderInfo.OrderId : item.OrderId
      getSplitOrder({ orderId, type: 'weixin' }).then(res => {
        if (type) {
          res.forEach(data => {
            data.Name = item.UserInfo.UserName
            data.Phone = item.UserInfo.TelPhone
          })
          res[res.length - 1].flag = true
        }

        this.splitOrderData = res
      })
    },
    // 退款确认
    handleConfirmRefund(item) {
      console.log(item)
      refund({ orderNo: item.OrderInfo.OrderNo }).then(res => {
        if (res) {
          this.$message.success('退款成功')
          // this.getRefundList(item, 0)
          // this.getOrderList()
          this.handleOrderSearch()
          this.refundVisible = false
        }
      })
    },
    // 重置添加箱子信息
    resetBox() {
      this.box = {
        BoxNo: null,
        TypeNo: 'Small',
        LockPlate: null,
        LockPosition: null,
        IsMember: null
      }
    },
    // 取消弹窗
    handleCancel() {
      this.dialogVisible = false
    },
    handleSizeChange(e) {
      this.boxListQuery.pageSize = e
      this.getBoxList()
    },
    handleCurrentChange(e) {
      this.boxListQuery.pageIndex = e
      this.getBoxList()
    },
    handleOrderSizeChange(e) {
      this.orderListQuery.pageSize = e
      this.getOrderList()
    },
    handleOrderCurrentChange(e) {
      this.orderListQuery.pageIndex = e
      this.getOrderList()
    },
    back() {
      this.$emit('back')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variables.scss";
.panel-group {
  margin-top: 18px;
  .card-panel-col{
    margin-bottom: 32px;
  }
  .card-panel {
    height: 168px;
    cursor: pointer;
    font-size: 24px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);
    display: flex;
    // &:hover {
    //   .card-panel-icon-wrapper {
    //     color: #fff;
    //   }
    //   .icon-people {
    //      background: #40c9c6;
    //   }
    //   .icon-message {
    //     background: #36a3f7;
    //   }
    //   .icon-money {
    //     background: #f4516c;
    //   }
    //   .icon-shopping {
    //     background: #34bfa3
    //   }
    // }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #333;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shopping {
      color: #34bfa3
    }
    .card-panel-icon-wrapper {
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
      .title{
        font-size: 22px;
        color: #999;
        margin-bottom: 24px;
      }
      .card-panel-num {
        font-size: 34px;
      }
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      text-align: right;
      margin-left: auto;
      flex-shrink: 0;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      img{
        height: 101px;
      }
    }
  }
}
.header{
  color: #409EFF;
  cursor: pointer;
  font-size: 16px;
}
.custom-col {
  margin-bottom: 15px;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #eeeeee;
}

.custom-card{
  font-size: 16px;
  b{
    display: flex;
    align-items: center;
    &::before{
      content: '';
      display: inline-block;
      width: 4px;
      height: 18px;
      background-color: $menuTextActive;
      margin-right: 13px;
      border-radius: 5px;
    }
  }
  .mb-30{
    display: flex;
    align-items: center;
  }
  ::v-deep {
    .el-input__inner{
      border-radius: 70px;
    }
  }
}
.custom-button{
  color: white;
  border:none
}
</style>
